import {
  generateId,
  getRandomText,
} from '@freelancer/datastore/testing/helpers';
import type { AppPlatformTypeApi } from 'api-typings/users/users';
import type { AppInstallTrackingRecord } from './app-install-tracking.model';

export interface AppInstallTrackingOptions {
  readonly userId: number;
  readonly platformType: AppPlatformTypeApi;
}

export function generateAppInstallTrackingObject({
  userId = generateId(),
  platformType,
}: AppInstallTrackingOptions): AppInstallTrackingRecord {
  return {
    id: generateId(),
    userId,
    deviceId: getRandomText(16),
    platformType,
  };
}
